import React from 'react'
export * from './styles'
export * from './Settings'
export * from './logger'
export * from './performance'
export * from './constants'
export * from './localStorage'
export * from './navigation'
export * from './api'
export * from './i18n'

export type { AppIcon } from './assets/icons'
export { IconNames, iconImages } from './assets/icons'
import * as AppForms from './forms'
import * as AppImages from './assets/images'
import * as StyleSheets from './stylesheets'

export { I18N } from './i18n'

export { default as licenses } from './license.json'
export { default as timestamp } from './timestamp.json'

export { customTextStyles } from './stylesheets/Text'

import { useBreakpointMatch as _useBreakpointMatch } from '@codeleap/web'
import { CreateOSAlert } from '@codeleap/common'

export const useBreakpointMatch = _useBreakpointMatch<any>

export const OSAlert = CreateOSAlert()

export { React, AppForms, AppImages, StyleSheets }
